import * as angular from 'angular';
import { SelectOption } from '@mode/shared/ui-angularjs';
import { ModalTheme, ModalType } from '@mode/shared/ui-angularjs';

enum DefaultAccessLevel {
  Query = 'query',
  View = 'view',
  None = 'none',
}

export const WORKSPACE_OPTIONS = [
  {
    label: 'Restricted',
    labelCaption: 'Grant access on an individual & group basis',
    value: DefaultAccessLevel.None,
    confirm: {
      title: 'Change Workspace connection access',
      content: `
          <span>
            Changing Workspace connection access to "Restricted" may impact members'
            ability to use reports, definitions, and datasources.
          </span>
          <p>
            Are you sure you want to change access type?
          </p>
        `,
      buttonConfirm: 'Change access',
      modalType: ModalType.Default,
      modalTheme: ModalTheme.DangerLight,
    },
  },
  {
    label: 'View',
    labelCaption: 'All Workspace members can view content built on this connection',
    value: DefaultAccessLevel.View,
  },
  {
    label: 'Query',
    labelCaption: 'All Workspace members can view content and query this connection',
    value: DefaultAccessLevel.Query,
  },
];

class ConnectionPermissionsDefaultAccessDropdownController {
  private selected: DefaultAccessLevel;
  private onSelect: ($args: { $option: SelectOption }) => void;
  private onInit: ($args: { $option: SelectOption }) => void;

  private options: SelectOption[];

  $onInit() {
    this.options = WORKSPACE_OPTIONS;

    if (this.onInit) {
      this.onInit({ $option: this.getSelected(this.selected) });
    }
  }

  getSelected(selectedValue: DefaultAccessLevel): SelectOption {
    return this.options.find((option) => option.value === selectedValue);
  }
}

export const ConnectionPermissionsDefaultAccessDropdownComponent: angular.IComponentOptions = {
  controller: ConnectionPermissionsDefaultAccessDropdownController,
  controllerAs: 'ctrl',
  bindings: {
    inputId: '@',
    inputName: '@',
    onSelect: '&?',
    onInit: '&?',
    selected: '@',
  },
  template: `
    <inline-select-field
      input-id="{{ ctrl.inputId }}"
      input-name="{{ ctrl.inputName }}"
      on-change="ctrl.onSelect({ $option: $option })"
      options="ctrl.options"
      selected="ctrl.getSelected(ctrl.selected)"
      title="Access Type"
    />
  `,
};
